import React from "react";
import ReporteComisionesSaldos from "../components/ReporteComisionesSaldos";

const InformeComisionesSaldos = () => {
  return (
    <>
      <ReporteComisionesSaldos />
    </>
  );
};

export default InformeComisionesSaldos;